var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 287 203.6",
    style: {
      enableBackground: "new 0 0 287 203.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7A57A3;}\r\n\t.st1{fill:#886CAE;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.9,0H6C2.7,0,0,2.7,0,6v82.8c0,3.3,2.7,6,6,6h32.7l31.4,32.5l-5.4-32.5h100.2c3.3,0,6-2.7,6-6V6 C170.9,2.7,168.2,0,164.9,0z M143.9,58.5c0,1.5-1.3,2.8-2.8,2.8H29.8c-1.5,0-2.8-1.3-2.8-2.8l0,0c0-1.5,1.3-2.8,2.8-2.8h111.3 C142.6,55.7,143.9,56.9,143.9,58.5L143.9,58.5z M141.1,47.3H29.8c-1.5,0-2.8-1.3-2.8-2.8c0-1.5,1.3-2.8,2.8-2.8h111.3 c1.5,0,2.8,1.3,2.8,2.8C143.9,46.1,142.6,47.3,141.1,47.3z M143.9,30.6c0,1.5-1.3,2.8-2.8,2.8H29.8c-1.5,0-2.8-1.3-2.8-2.8v0 c0-1.5,1.3-2.8,2.8-2.8h111.3C142.6,27.8,143.9,29,143.9,30.6L143.9,30.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.1,82.3v82.8c0,3.3,2.7,6,6,6h100.2l-5.4,32.5l31.4-32.5H281c3.3,0,6-2.7,6-6V82.3c0-3.3-2.7-6-6-6H122.1 C118.8,76.2,116.1,79,116.1,82.3z M143.1,134.7c0-1.5,1.3-2.8,2.8-2.8h111.3c1.5,0,2.8,1.3,2.8,2.8l0,0c0,1.5-1.3,2.8-2.8,2.8H145.9 C144.4,137.5,143.1,136.3,143.1,134.7L143.1,134.7z M143.1,120.8c0-1.5,1.3-2.8,2.8-2.8h111.3c1.5,0,2.8,1.3,2.8,2.8 c0,1.5-1.3,2.8-2.8,2.8H145.9C144.4,123.6,143.1,122.3,143.1,120.8z M143.1,106.8c0-1.5,1.3-2.8,2.8-2.8h111.3 c1.5,0,2.8,1.3,2.8,2.8v0c0,1.5-1.3,2.8-2.8,2.8H145.9C144.4,109.6,143.1,108.4,143.1,106.8L143.1,106.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatimage);
export default __webpack_public_path__ + "static/media/Chat image.423f388a50f87265f0de57bf92be944f.svg";
export { ForwardRef as ReactComponent };